import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import '../../../sass/components/flexibleModules/homepage/_components.HomepagePromoModule.scss';

const HomepagePromoModule = ({ data }) => {
    return (
        <div className="cp-homepagePromoModule">
            <div data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease" className="cp-homepagePromoModule__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.homepagePromoModuleBackgroundImage &&
                    <div className="cp-homepagePromoModule__section l--flex" style={{ backgroundImage: `url('${data.homepagePromoModuleBackgroundImage.sourceUrl}')` }}>
                        <div className="cp-homepagePromoModule__section-content">
                            {data.homepagePromoModuleSubHeader &&
                                <h3>{data.homepagePromoModuleSubHeader}</h3>
                            }
                            {data.homepagePromoModuleMainHeader &&
                                <h2>{data.homepagePromoModuleMainHeader}</h2>
                            }
                            {data.homepagePromoModuleTeaser &&
                                <div dangerouslySetInnerHTML={{ __html: data.homepagePromoModuleTeaser }} />
                            }
                            {data.homepagePromoModuleButton &&
                                <a className="l-button" href={data.homepagePromoModuleButton.url} target={data.homepagePromoModuleButton.target} dangerouslySetInnerHTML={{__html: data.homepagePromoModuleButton.title}} />
                            }
                        </div>
                    </div>
                }
                {data.homepagePromoModuleMainImage &&
                    <div className="cp-homepagePromoModule__section l--flex l-layoutTwo">
                        <div className="cp-homepagePromoModule__section-image">
                            {data.homepagePromoModuleMainImage &&
                                <GatsbyImage image={getImage(data.homepagePromoModuleMainImage.gatsbyImage)} alt={data.homepagePromoModuleMainImage.altText} />
                            }
                        </div>
                        <div className="cp-homepagePromoModule__section-content">
                            {data.homepagePromoModuleSubHeader &&
                                <h3>{data.homepagePromoModuleSubHeader}</h3>
                            }
                            {data.homepagePromoModuleMainHeader &&
                                <h2>{data.homepagePromoModuleMainHeader}</h2>
                            }
                            {data.homepagePromoModuleTeaser &&
                                <div dangerouslySetInnerHTML={{ __html: data.homepagePromoModuleTeaser }} />
                            }
                            {data.homepagePromoModuleButton &&
                                <a className="l-button" href={data.homepagePromoModuleButton.url} target={data.homepagePromoModuleButton.target} dangerouslySetInnerHTML={{ __html: data.homepagePromoModuleButton.title }} />
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default HomepagePromoModule;